/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IrrConfigRWR } from './irrConfigRWR';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { IrrSubscriptionModesEnum } from './irrSubscriptionModesEnum';
import { IrrConfigSettingsItem } from './irrConfigSettingsItem';
import { IrrConfigVmcNetwork } from './irrConfigVmcNetwork';
import { IrrConfigServiceNetwork } from './irrConfigServiceNetwork';
import { IrrReConfigAuth } from './irrReConfigAuth';
import { SaasConfigIrrNetwork } from './saasConfigIrrNetwork';


/**
 * IRR re-config specification
 */
export interface IrrReConfigSpec { 
    service_type: ServiceTypeEnum;
    /**
     * IRR FQDN
     */
    irr_fqdn: string;
    auth?: IrrReConfigAuth;
    irrNetwork?: SaasConfigIrrNetwork;
    mode?: IrrSubscriptionModesEnum;
    rwrConfig?: IrrConfigRWR;
    serviceNetwork?: IrrConfigServiceNetwork;
    settings?: Array<IrrConfigSettingsItem>;
    vmcNetwork?: IrrConfigVmcNetwork;
}
export namespace IrrReConfigSpec {
}


